<template>
    <div class="welcome">
        Bok, {{fullName}}!

        <div>Evo malo statistike!</div>
        <div>Broj aktivnih korisnika: {{allUsers.length}}</div>
        <div>Broj posjetitelja: {{allUsers.filter(user => user.role === 'Guest' || user.role === 'HonoraryGuest').length}}</div>
        <div>Broj isprintanih posjetitelja: {{allUsers.filter(user => (user.role === 'Guest' || user.role === 'HonoraryGuest') && user.isPrinted).length}}</div>
        <div>Broj sponzora: {{allUsers.filter(user => user.role === 'Sponsor').length}}</div>
        <div>Broj ostvarenih bodova: {{this.allUsers.map(user => user.points !== null ? user.points : 0).reduce((a,b) => a + b, 0)}}</div>
        <div class="title">Prijave na radionice:</div>
        <div v-for="(application, index) in workshopApplications" v-bind:key="`${application}-${index}`">{{application}}</div>
        <div class="title">Prijave na fly talkove:</div>
        <div v-for="(application, index) in flytalksApplications" v-bind:key="`${application}-${index}`">{{application}}</div>
    </div>
</template>

<script>
    export default {
        name: 'Welcome',
        data() {
            return {
                fullName: "",
                allUsers: [],
                workshopApplications: [],
                flytalksApplications: []
            }
        },
        created() {
            this.fullName = this.$decode(localStorage.getItem('token')).fullname;
        
            this.$axios.get(`${this.$API_URL}/user/all-users`)
            .then(response => {
               this.allUsers = response.data;
            });

            this.$axios.get(`${this.$API_URL}/user/all-workshop-applications`)
            .then(response => {
               this.workshopApplications = response.data;
            });

            this.$axios.get(`${this.$API_URL}/user/all-fly-talks-applications`)
            .then(response => {
               this.flytalksApplications = response.data;
            });
        }
    }
</script>

<style scoped>
    .welcome {
        margin-left: 10%;
    }

    .welcome .title {
        margin-top: 50px;
    }
</style>